import { createSlice } from "@reduxjs/toolkit";

import * as actions from "./Actions";

const initialState = {
  isLoading: false,
  error: "",
  success: false,
  data: {},
};

const chooseYourMoveSlice = createSlice({
  name: "chooseYourMove",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(actions.getChooseYourMovePage.pending, (state) => ({
        ...state,
        isLoading: true,
        success: false,
        error: "",
      }))
      .addCase(
        actions.getChooseYourMovePage.fulfilled,
        (state, { payload }) => {
          return {
            ...state,
            isLoading: false,
            success: true,
            data: payload?.data,
          };
        }
      )
      .addCase(
        actions.getChooseYourMovePage.rejected,
        (state, { payload }) => ({
          ...state,
          isLoading: false,
          error: payload || "",
        })
      );
  },
});

export { getChooseYourMovePage } from "./Actions";

export default chooseYourMoveSlice.reducer;
